export default "__VITE_ASSET__DgfuIIBx__"